import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{mediaData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{mediaData.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.items.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative h-44 md:h-48 overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={`视频专区 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="text-background-50 text-xs font-medium">{item.duration}</span>
                  <span className="text-background-50 text-xs font-medium">{item.views} 次播放</span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 text-background-50 text-xs font-bold rounded whitespace-nowrap ${
                    item.tag === '爆' ? 'bg-primary-500' : item.tag === '新' ? 'bg-accent-500' : 'bg-secondary-500'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 flex items-center justify-center bg-background-50/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                  <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}